exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "td[data-v-efce6f34]{min-width:100px}table thead th[data-v-efce6f34]{white-space:nowrap}", ""]);

// exports
